/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosInstance, AxiosResponse } from "axios";
import { GetAllProductListApiResponse } from "../../@types/DRO/GetAllProductResponse";
import { erpAxios, getAuthToken } from "../axiosInstances";

export class GetAllProductListApi {
  public static api = new GetAllProductListApi();
  private instance = erpAxios;

  getToken() {
    return getAuthToken();
  }

  async getAllProductsList(warehouseId:number): Promise<GetAllProductListApiResponse> {
    try {
        const response: AxiosResponse<GetAllProductListApiResponse> = await this.instance.get("/erp/api/v1/inventory/product/list", {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
            },
            params:{
                warehouseId
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching predictions latest data", error);
        throw error;
    }
}

}
